import e from "axios";
//#region src/apps.ts
function t(e) {
	return {
		async list() {
			return (await e.get("/auth/me/pinned-apps")).data ?? [];
		},
		async add(t) {
			return (await e.post("/auth/me/pinned-apps", { app_id: t })).data;
		},
		async remove(t) {
			await e.delete(`/auth/me/pinned-apps/${encodeURIComponent(t)}`);
		}
	};
}
function n(e) {
	return {
		async list(t) {
			let n = {};
			return t?.mobile_only !== void 0 && (n.mobile_only = String(t.mobile_only)), t?.web_only !== void 0 && (n.web_only = String(t.web_only)), (await e.get("/apps", { params: n })).data ?? [];
		},
		pinned: t(e)
	};
}
//#endregion
//#region src/errors.ts
function r(e) {
	if (!e || typeof e != "object") return !1;
	let t = e;
	if (t.response) return !1;
	if (t.isAxiosError) return !0;
	let n = t.code;
	return n === "ERR_NETWORK" || n === "ECONNABORTED" || n === "ETIMEDOUT";
}
//#endregion
//#region src/jwt.ts
function i(e) {
	if (!e) return null;
	try {
		let t = e.split(".");
		if (t.length < 2) return null;
		let n = t[1].replace(/-/g, "+").replace(/_/g, "/");
		return JSON.parse(atob(n));
	} catch {
		return null;
	}
}
function a(e, t = 60) {
	let n = i(e);
	return n?.exp ? n.exp - Math.floor(Date.now() / 1e3) < t : !0;
}
//#endregion
//#region src/permissions.ts
var o = "system.super_admin";
function s(e, t) {
	function n(e) {
		if (e) {
			let t = i(e)?.permissions;
			if (Array.isArray(t)) return new Set(t.filter((e) => typeof e == "string"));
		}
		if (t) {
			let e = t.getUser()?.permissions;
			if (Array.isArray(e)) return new Set(e.filter((e) => typeof e == "string"));
		}
		return /* @__PURE__ */ new Set();
	}
	return {
		list(t) {
			return n(t === void 0 ? e() : t);
		},
		has(t, r) {
			let i = n(r === void 0 ? e() : r);
			return i.has(t) || i.has(o);
		}
	};
}
//#endregion
//#region src/storage.ts
var c = "auth_token", l = "auth_refresh_token", u = "user", d = "agio_csrf", f = {
	ACCESS_TOKEN: c,
	REFRESH_TOKEN: l,
	USER: u
};
function p(e) {
	if (!e || typeof e != "object") return !1;
	let t = e;
	return typeof t.get == "function" && typeof t.set == "function" && typeof t.remove == "function";
}
function m() {
	if (typeof document > "u") return !1;
	try {
		return document.cookie.includes(`${d}=`);
	} catch {
		return !1;
	}
}
function h() {
	if (typeof document > "u") return null;
	try {
		let e = document.cookie.match(RegExp(`(?:^|;\\s*)${d}=([^;]+)`));
		return e ? decodeURIComponent(e[1]) : null;
	} catch {
		return null;
	}
}
function g(e, t) {
	try {
		return e.getItem(t);
	} catch {
		return null;
	}
}
function _(e) {
	return g(localStorage, e) ?? g(sessionStorage, e);
}
function v(e) {
	if (!e) return null;
	try {
		return JSON.parse(e);
	} catch {
		return null;
	}
}
function y(e) {
	function t(t) {
		return t === !0 ? localStorage : t === !1 ? sessionStorage : e === "persistent" ? localStorage : e === "session" ? sessionStorage : g(localStorage, c) ? localStorage : g(sessionStorage, c) ? sessionStorage : localStorage;
	}
	function n(e) {
		try {
			e.removeItem(c), e.removeItem(l), e.removeItem(u);
		} catch {}
	}
	return {
		mode: "bearer",
		getToken: () => _(c),
		getRefreshToken: () => _(l),
		getUser: () => v(_(u)),
		isAuthenticated: () => !!_(c),
		getCsrfToken: () => null,
		async setSession(e, r) {
			let i = t(r);
			n(i === localStorage ? sessionStorage : localStorage), e?.access_token && i.setItem(c, e.access_token), e?.refresh_token && i.setItem(l, e.refresh_token), e?.user && i.setItem(u, JSON.stringify(e.user));
		},
		clearSession() {
			n(localStorage), n(sessionStorage);
		},
		async hydrate() {},
		subscribeCrossTab(e) {
			let t = (t) => {
				t.key === c && !t.newValue && e();
			};
			return window.addEventListener("storage", t), () => window.removeEventListener("storage", t);
		}
	};
}
function b(e) {
	let t = null, n = null, r = null;
	async function i(e) {
		return await Promise.resolve(e);
	}
	return {
		mode: "bearer",
		getToken: () => t,
		getRefreshToken: () => n,
		getUser: () => v(r),
		isAuthenticated: () => !!t,
		getCsrfToken: () => null,
		async setSession(a) {
			t = a?.access_token ?? null, n = a?.refresh_token ?? null, r = a?.user ? JSON.stringify(a.user) : null, t === null ? await i(e.remove(c)) : await i(e.set(c, t)), n === null ? await i(e.remove(l)) : await i(e.set(l, n)), r === null ? await i(e.remove(u)) : await i(e.set(u, r));
		},
		clearSession() {
			t = null, n = null, r = null, Promise.resolve(e.remove(c)).catch(() => {}), Promise.resolve(e.remove(l)).catch(() => {}), Promise.resolve(e.remove(u)).catch(() => {});
		},
		async hydrate() {
			let [a, o, s] = await Promise.all([
				i(e.get(c)),
				i(e.get(l)),
				i(e.get(u))
			]);
			t = a ?? null, n = o ?? null, r = s ?? null;
		},
		subscribeCrossTab() {
			return () => {};
		}
	};
}
function x() {
	let e = null;
	function t() {
		return g(localStorage, l);
	}
	function n() {
		return v(g(localStorage, u));
	}
	function r(e, t) {
		try {
			t ? localStorage.setItem(e, t) : localStorage.removeItem(e);
		} catch {}
	}
	function a() {
		e = null;
		try {
			localStorage.removeItem(l), localStorage.removeItem(u);
		} catch {}
		try {
			typeof document < "u" && (document.cookie = `${d}=; path=/; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT`);
		} catch {}
	}
	function o() {
		return m() || !!g(localStorage, l);
	}
	return {
		mode: "cookie",
		getToken: () => null,
		getRefreshToken: t,
		getUser: n,
		isAuthenticated: o,
		getCsrfToken: () => e ?? h(),
		async setSession(t) {
			r(l, t?.refresh_token);
			let n = null;
			if (t?.user && (n = { ...t.user }, t.access_token)) try {
				let e = i(t.access_token)?.permissions;
				Array.isArray(e) && (n.permissions = e.filter((e) => typeof e == "string"));
			} catch {}
			r(u, n ? JSON.stringify(n) : null), t?.csrf_token && (e = t.csrf_token);
		},
		clearSession() {
			a();
		},
		async hydrate() {},
		subscribeCrossTab(e) {
			let t = (t) => {
				t.key === l && !t.newValue && e();
			};
			return typeof window > "u" ? () => {} : (window.addEventListener("storage", t), () => window.removeEventListener("storage", t));
		}
	};
}
function S(e) {
	return p(e) ? b(e) : e === "cookie" || e === "auto" && m() ? x() : y(e);
}
//#endregion
//#region src/auth.ts
function C(e) {
	let { storage: t, client: n, refreshBufferSeconds: i, hooks: o } = e, c = s(() => t.getToken(), t), l = null;
	async function u() {
		let e = t.getRefreshToken();
		if (!e) throw Error("missing_refresh_token");
		let r = typeof localStorage < "u" ? !!localStorage.getItem(f.ACCESS_TOKEN) : void 0, i = await n.post("/auth/sessions/refresh", { refresh_token: e });
		return await t.setSession(i.data, r), i.data.access_token;
	}
	let d = {
		async login(e, r, i) {
			let a = i?.persistent ?? !0, o = await n.post("/auth/sessions", {
				email: e,
				password: r
			});
			return o.data?.requires_2fa || await t.setSession(o.data, a), o.data;
		},
		async complete2fa(e, r, i) {
			let a = i?.persistent ?? !0, o = await n.post("/auth/2fa/login", {
				partial_token: e,
				code: r
			});
			return await t.setSession(o.data, a), o.data;
		},
		async logout() {
			let e = t.isAuthenticated();
			if (o.beforeLogout) try {
				await o.beforeLogout();
			} catch (e) {
				console.warn("[agiohub-js] beforeLogout hook threw, continuing logout:", e);
			}
			try {
				e && await n.delete("/auth/sessions/current");
			} catch {}
			t.clearSession(), o.onUnauthenticated("logout");
		},
		async refresh() {
			if (l) return l;
			l = u();
			try {
				return await l;
			} finally {
				l = null;
			}
		},
		clearSession: () => t.clearSession(),
		hydrate: () => t.hydrate(),
		getToken: () => t.getToken(),
		getRefreshToken: () => t.getRefreshToken(),
		getUser: () => t.getUser(),
		isAuthenticated: () => t.isAuthenticated(),
		getPermissions: () => c.list(),
		hasPermission: (e) => c.has(e),
		async ensureFreshToken() {
			if (t.mode === "cookie") return;
			let e = t.getToken();
			if (e && a(e, i)) try {
				await d.refresh();
			} catch (e) {
				if (r(e)) return;
				t.clearSession(), o.onUnauthenticated("refresh-failed");
			}
		}
	};
	return d;
}
//#endregion
//#region src/client.ts
var w = new Set([
	"post",
	"put",
	"patch",
	"delete"
]), T = "X-Agio-CSRF";
function E(e) {
	return !!e && e.includes("/auth/sessions");
}
function D(e) {
	return E(e) || !!e && e.includes("/auth/2fa/login");
}
function O(t, n = {}) {
	let r = e.create({ baseURL: t });
	return n.withCredentials && (r.defaults.withCredentials = !0), r;
}
function k(e) {
	let { client: t, auth: n, hooks: i, storage: a } = e;
	t.interceptors.request.use(async (e) => {
		if (D(e.url) || await n.ensureFreshToken(), a.mode === "cookie") {
			let t = (e.method || "get").toLowerCase();
			if (w.has(t)) {
				let t = a.getCsrfToken();
				t && e.headers.set(T, t);
			}
			return e;
		}
		let t = n.getToken();
		return t && e.headers.set("Authorization", `Bearer ${t}`), e;
	}), t.interceptors.response.use((e) => e, async (e) => {
		let o = e.config;
		if (!o) return Promise.reject(e);
		let s = e.response?.status, c = e.response?.data?.detail;
		if (s === 403 && c === "auth.password_change_required") return i.onPasswordChangeRequired(e), Promise.reject(e);
		if (s === 401 && !o._retry && !D(o.url)) {
			o._retry = !0;
			try {
				if (await n.refresh(), a.mode === "cookie") return t(o);
				let e = n.getToken();
				return e && o.headers.set("Authorization", `Bearer ${e}`), t(o);
			} catch (t) {
				return r(t) ? Promise.reject(e) : (a.clearSession(), i.onUnauthenticated("refresh-failed"), Promise.reject(e));
			}
		}
		return Promise.reject(e);
	});
}
//#endregion
//#region src/hooks.ts
function A(e = {}) {
	return {
		onPasswordChangeRequired: e.onPasswordChangeRequired ?? ((e) => {
			console.warn("[agiohub-js] onPasswordChangeRequired hook not provided. Hub answered 403 password_change_required but no redirect will happen.", e);
		}),
		onUnauthenticated: e.onUnauthenticated ?? ((e) => {
			console.warn(`[agiohub-js] onUnauthenticated('${e}') hook not provided. Session is gone but no redirect will happen.`);
		}),
		beforeLogout: e.beforeLogout
	};
}
//#endregion
//#region src/preferences.ts
function j(e) {
	return {
		async fetch() {
			return (await e.get("/auth/me/preferences")).data?.preferences ?? {};
		},
		async save(t) {
			return (await e.put("/auth/me/preferences", { preferences: t ?? {} })).data?.preferences ?? {};
		}
	};
}
//#endregion
//#region src/bootstrap.ts
var M = "agiohub:bootstrap", N = 300 * 1e3, P = "/apps/config/bootstrap", F = class extends Error {
	code;
	cause;
	constructor(e, t, n) {
		super(t), this.name = "BootstrapError", this.code = e, this.cause = n;
	}
};
function I(e) {
	return e.endsWith("/") ? e.slice(0, -1) : e;
}
function L() {
	try {
		let e = sessionStorage.getItem(M);
		if (!e) return null;
		let t = JSON.parse(e);
		return typeof t?.api_base != "string" || typeof t?.fetched_at != "number" || !t?.secrets || !t?.app_info ? null : t;
	} catch {
		return null;
	}
}
function R(e) {
	let t = {
		...e,
		fetched_at: Date.now()
	};
	try {
		sessionStorage.setItem(M, JSON.stringify(t));
	} catch (e) {
		console.warn("[agiohub-js] Failed to persist bootstrap cache to sessionStorage:", e);
	}
}
function z(e, t) {
	return e.fetched_at + t > Date.now();
}
function B(e) {
	let t = { ...e };
	return {
		get: (e) => t[e],
		has: (e) => Object.prototype.hasOwnProperty.call(t, e),
		keys: () => Object.keys(t)
	};
}
async function V(t, n) {
	let r = `${I(t)}${P}`, i;
	try {
		i = await e.post(r, void 0, { headers: { Authorization: `Bearer ${n}` } });
	} catch (e) {
		throw e.response?.status === 401 ? new F("invalid_app_token", "The app token was rejected by the Hub. Verify AGIOHUB_APP_TOKEN or rotate the credential.", e) : new F("network_error", `Could not reach the Hub at ${t}. Ensure VITE_AGIOHUB_HUB_URL points to a running Hub.`, e);
	}
	let a = i.data;
	if (!a || typeof a.api_base != "string" || !a.app_info || !a.secrets) throw new F("malformed_response", "Bootstrap response is missing required fields (api_base, app_info, secrets).");
	return a;
}
var H = 0;
async function U(e) {
	if (!e || typeof e.hubUrl != "string" || !e.hubUrl) throw new F("malformed_response", "[agiohub-js] bootstrapHubClient requires options.hubUrl");
	if (typeof e.appToken != "string" || !e.appToken) throw new F("malformed_response", "[agiohub-js] bootstrapHubClient requires options.appToken");
	H += 1, H > 1 && console.warn("[agiohub-js] bootstrapHubClient called more than once. Multiple instances are not supported in v0.x.");
	let t = e.cacheTtlMs ?? N, r = L(), i = null;
	if (r && z(r, t) && (i = {
		api_base: r.api_base,
		secrets: r.secrets,
		app_info: r.app_info
	}), i === null) try {
		i = await V(e.hubUrl, e.appToken), R(i);
	} catch (t) {
		if (r && t instanceof F && t.code === "network_error") i = {
			api_base: r.api_base,
			secrets: r.secrets,
			app_info: r.app_info
		};
		else {
			let n = t instanceof F ? t : new F("network_error", "Unexpected error during bootstrap.", t);
			throw e.hooks?.onBootstrapFailed ? e.hooks.onBootstrapFailed({
				code: n.code,
				message: n.message,
				cause: n.cause
			}) : console.warn(`[agiohub-js] Bootstrap failed (${n.code}): ${n.message}. Provide hooks.onBootstrapFailed to handle this in the app (e.g. show an error screen).`), n;
		}
	}
	let a = e.storage ?? "auto", o = p(a);
	if (!o && typeof window > "u") throw new F("malformed_response", "[agiohub-js] No browser detected and no StorageAdapter provided. Pass a StorageAdapter via options.storage to use bootstrapHubClient outside a browser.");
	let c = e.refreshBufferSeconds ?? 60, l = A(e.hooks), u = S(a), d = O(e.hubUrl, { withCredentials: u.mode === "cookie" }), f = C({
		storage: u,
		client: d,
		refreshBufferSeconds: c,
		hooks: l
	}), m = j(d), h = s(() => u.getToken(), u), g = n(d);
	return k({
		client: d,
		auth: f,
		hooks: l,
		storage: u
	}), o || u.subscribeCrossTab(() => l.onUnauthenticated("cross-tab")), {
		auth: f,
		client: d,
		permissions: h,
		preferences: m,
		apps: g,
		secrets: B(i.secrets),
		appInfo: i.app_info
	};
}
//#endregion
//#region src/index.ts
var W = "0.4.0", G = 0;
function K(e) {
	if (!e || typeof e.baseURL != "string" || !e.baseURL) throw Error("[agiohub-js] createHubClient requires options.baseURL");
	G += 1, G > 1 && console.warn("[agiohub-js] createHubClient called more than once. Multiple instances are not supported in v0.x.");
	let t = e.storage ?? "auto", r = p(t);
	if (!r && typeof window > "u") throw Error("[agiohub-js] No browser detected and no StorageAdapter provided. Pass a StorageAdapter via options.storage to use the SDK outside a browser.");
	let i = e.refreshBufferSeconds ?? 60, a = A(e.hooks), o = S(t), c = O(e.baseURL, { withCredentials: o.mode === "cookie" }), l = C({
		storage: o,
		client: c,
		refreshBufferSeconds: i,
		hooks: a
	}), u = j(c), d = s(() => o.getToken(), o), f = n(c);
	return k({
		client: c,
		auth: l,
		hooks: a,
		storage: o
	}), r || o.subscribeCrossTab(() => a.onUnauthenticated("cross-tab")), {
		auth: l,
		client: c,
		permissions: d,
		preferences: u,
		apps: f
	};
}
//#endregion
export { F as BootstrapError, W as VERSION, U as bootstrapHubClient, K as createHubClient, i as decodeTokenPayload, a as isTokenExpiringSoon };

//# sourceMappingURL=index.js.map